import { render, staticRenderFns } from "./tabEmployeeSummaryBranch.vue?vue&type=template&id=68a299c6"
import script from "./tabEmployeeSummaryBranch.vue?vue&type=script&lang=js"
export * from "./tabEmployeeSummaryBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports